enum ApprovalStatusEnum {
    Approved = 'APPROVED',
    Draft = 'DRAFT',
    Legacy = 'LEGACY',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
}

export default ApprovalStatusEnum;
